module.exports = __webpack_public_path__ + "static/media/miwa_card_read_close.3e988942.svg";